export function inr(amount) {
  const n = Number(amount || 0);
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)}Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2)}L`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(1)}K`;
  return `₹${n.toLocaleString("en-IN")}`;
}

export function inrPlain(amount) {
  return `₹${Number(amount || 0).toLocaleString("en-IN")}`;
}

export function fmtNumber(value, maximumFractionDigits = 1) {
  const n = Number(value || 0);
  return n.toLocaleString("en-IN", {
    maximumFractionDigits,
    minimumFractionDigits: 0,
  });
}

export function fmtPercent(value, maximumFractionDigits = 0) {
  return `${fmtNumber(value, maximumFractionDigits)}%`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function fmtRelative(iso) {
  if (!iso) return "";
  const diff = (new Date(iso).getTime() - Date.now()) / 1000;
  const abs = Math.abs(diff);
  const sign = diff < 0 ? "ago" : "from now";
  if (abs < 60) return `just now`;
  if (abs < 3600) return `${Math.round(abs / 60)}m ${sign}`;
  if (abs < 86400) return `${Math.round(abs / 3600)}h ${sign}`;
  return `${Math.round(abs / 86400)}d ${sign}`;
}

export const STATUS_COLORS = {
  Occupied: "bg-emerald-100 text-emerald-800 border-emerald-200",
  Available: "bg-red-100 text-red-800 border-blue-200",
  Reserved: "bg-amber-100 text-amber-800 border-amber-200",
  Maintenance: "bg-blue-100 text-blue-800 border-blue-200",
  active: "bg-emerald-100 text-emerald-800 border-emerald-200",
  inactive: "bg-slate-200 text-slate-700 border-slate-300",
};

export const CITIES = [
  "Pune", "Mumbai", "Kolhapur", "Nagpur", "Nashik",
  "Aurangabad", "Thane", "Solapur", "Kolkata", "Delhi", "Bangalore", "Chennai",
];

export const PLAN_TYPES = ["Standard", "Pro", "Premium", "Enterprise"];
